import React, { useState } from 'react'
import Icon from 'blocks.simple/icon/icon'
import InputMask from 'react-input-mask'
import Datepicker from 'blocks.simple/datepicker/datepicker'
import EditTextMethods, { getTimeMaskValidationProps } from './editText.local.methods'

import { cn } from 'ethcss'
import rawStyles from './editText.jcss'
import { text as textStyles } from 'theme'
import item from 'blocks.simple/item/item.jcss'
import translate from 'core/translate'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { getThemeStyleValue } from 'theme/colors'
import moment from 'moment/moment'
import type { EditTextDatePickerRef, EditTextProps } from './editText.types'

const styles = (rawStyles as unknown) as Record<string, string>

export const EditTextPassword = <Value,>(p_: EditTextProps<Value>) => {
    const [isShow, setShow] = useState(false)

    return (
        <EditText
            {...p_}
            type={isShow || p_.autocompletePasswordOff ? 'text' : 'password'}
            securityView={!isShow && p_.autocompletePasswordOff}
            icon={isShow ? 'viewHide' : 'view'}
            iconColor={getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable}
            iconTooltip={{
                title: isShow ? translate('hidePassword') : translate('showPassword'),
            }}
            onIconClick={() => setShow(!isShow)}
        />
    )
}

class EditText<Value = string> extends EditTextMethods<Value> {
    render() {
        const props = this.props
        const className = props.className || ''
        const s_ = this.state
        const {
            onEndTyping,
            onIconClick,
            defaultFocus,
            inputRef,
            containerClass,
            showIconOnHover,
            rounded = 'full_mini',
            textSize = 'normal',
            indentSize = 'normal',
            iconColor,
            iconTooltip,
            dateValue,
            error,
            errorBorder,
            iconSize = '20',
            mod = 'default',
            rows = '3',
            cols,
            label,
            popperPlacement = 'bottom-start',
            max = 1920,
            valueType = '',
            labelColor,
            disableWheel,
            errorText,
            ...p_
        } = props

        error && (p_.icon = 'close')
        p_.type === 'date' && !p_.icon && (p_.icon = 'date')
        const wrapperClassName = cn(
            styles.input,
            className,
            {
                [styles.error]: error || errorBorder,
                [styles.validationBorder]: p_.validationBorder,
            },
            styles[`input_type_${mod}`],
            textStyles[textSize],
            item[`indent_${indentSize}`],
            item[`rounded_${rounded}`]
        )

        const labelClassName = cn(styles.label, styles[`label_type_${mod}`], textStyles[textSize])
        const inputTypeCheck = () => {
            return valueType === 'screenshot'
        }
        const onKeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (p_.type === 'number' && p_.min !== undefined && p_.min >= 0) {
                this.preventMinus(e)
            }

            if (e.key === 'Enter' && p_.onEnterKeyDown) {
                p_.onEnterKeyDown(e)
            }
        }
        return (
            <div
                className={cn(
                    p_.fullHeight ? styles.fullHeight : '',
                    { [styles.wrapper]: !containerClass },
                    containerClass,
                    {
                        [styles.hoverIconWrapper]: showIconOnHover,
                        [styles.date]: p_.type === 'date',
                    }
                )}
            >
                {label && (
                    <label
                        htmlFor={p_.id !== undefined ? String(p_.id) : undefined}
                        className={labelClassName}
                        style={{ color: labelColor ? labelColor : 'black' }}
                    >
                        {label}
                    </label>
                )}
                {!p_.mask && p_.type !== 'date' && (
                    <div style={{ height: '100%' }}>
                        <div className={cn(p_.fullHeight ? styles.fullHeight : '', styles.inputWrapper)}>
                            {p_.type === 'area' && (
                                <textarea
                                    {...p_}
                                    id={p_.id !== undefined ? String(p_.id) : undefined}
                                    value={(p_.value as unknown) as string | number | string[] | undefined}
                                    defaultValue={
                                        (p_.defaultValue as unknown) as string | number | string[] | undefined
                                    }
                                    rows={typeof rows === 'string' ? Number(rows) : rows}
                                    cols={typeof cols === 'string' ? Number(cols) : cols}
                                    className={wrapperClassName}
                                    onChange={this.onChange}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    ref={(input) => {
                                        this.inputFocus = input
                                    }}
                                />
                            )}
                            {p_.type !== 'area' && (
                                <>
                                    {inputTypeCheck() && s_.minValueError && s_.maxValueError && (
                                        <div className={styles.paddingTextError}>
                                            {translate('screenshotMin') + ' ' + (max + 1)}
                                        </div>
                                    )}
                                    <input
                                        onKeyDown={onKeydown}
                                        tabIndex={p_.tabindex !== undefined ? Number(p_.tabindex) : undefined}
                                        {...p_}
                                        id={p_.id !== undefined ? String(p_.id) : undefined}
                                        value={(p_.value as unknown) as string | number | string[] | undefined}
                                        defaultValue={
                                            (p_.defaultValue as unknown) as string | number | string[] | undefined
                                        }
                                        className={cn(
                                            item.ellipsisPure,
                                            inputTypeCheck() && s_.minValueError && styles.error_type_withBorder,
                                            inputTypeCheck() && s_.maxValueError && styles.error_type_withBorder,
                                            wrapperClassName,
                                            p_.securityView ? styles.securityView : ''
                                        )}
                                        onChange={inputTypeCheck() ? this.onChangeScreen : this.onChange}
                                        onFocus={this.onFocus}
                                        onBlur={this.onBlur}
                                        // onWheel={p_.type === 'number' ? this.onWheel : undefined}
                                        ref={(input) => {
                                            this.inputFocus = input
                                        }}
                                    />
                                </>
                            )}
                            {p_.icon && (
                                <div
                                    className={styles.icon}
                                    onMouseDown={this.onIconMouseDown}
                                    onClick={error ? undefined : this.onIconClick}
                                >
                                    <Icon
                                        type={p_.icon}
                                        color={error ? 'error' : this.getIconColor(iconColor, mod)}
                                        size={error ? 11 : iconSize}
                                        tooltip={iconTooltip}
                                        containerClass={p_.iconClassName}
                                        onClick={
                                            error
                                                ? (e: React.MouseEvent) => {
                                                      e.preventDefault()
                                                      e.stopPropagation()
                                                      this.onIconClick(e as React.MouseEvent<HTMLDivElement>)
                                                  }
                                                : undefined
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        {error && (
                            <div className={styles.errorContainer}>
                                <span className={cn(styles.errorText, styles[`errorText_type_${mod}`])}>{error}</span>
                            </div>
                        )}
                    </div>
                )}
                {p_.mask && p_.type !== 'date' && (
                    <div>
                        <div className={styles.inputWrapper}>
                            <InputMask
                                {...p_}
                                {...getTimeMaskValidationProps(p_.mask)}
                                mask={p_.mask}
                                id={p_.id !== undefined ? String(p_.id) : undefined}
                                value={(p_.value as unknown) as string | number | string[] | undefined}
                                defaultValue={(p_.defaultValue as unknown) as string | number | string[] | undefined}
                                className={wrapperClassName}
                                onChange={this.onChange}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                inputRef={(input: HTMLInputElement | null) => {
                                    this.inputFocus = input
                                }}
                            />
                            {p_.icon && (
                                <div
                                    className={styles.icon}
                                    onMouseDown={this.onIconMouseDown}
                                    onClick={error ? undefined : this.onIconClick}
                                >
                                    <Icon
                                        type={p_.icon}
                                        color={this.getIconColor(iconColor, mod)}
                                        size={error ? 11 : iconSize}
                                    />
                                </div>
                            )}
                        </div>
                        {error && (
                            <div className={styles.errorContainer}>
                                <span className={cn(styles.errorText, styles[`errorText_type_${mod}`])}>{error}</span>
                            </div>
                        )}
                    </div>
                )}
                {p_.type === 'date' && (
                    <div>
                        <div className={styles.inputWrapper}>
                            <Datepicker
                                {...p_}
                                className={cn(wrapperClassName, styles.dateWrapper)}
                                onChange={this.onChange}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                selected={
                                    dateValue
                                        ? moment(dateValue as moment.MomentInput).isValid()
                                            ? moment(dateValue as moment.MomentInput).toDate()
                                            : null
                                        : null
                                }
                                popperPlacement={popperPlacement}
                                datepickerRef={(input: EditTextDatePickerRef | null) => {
                                    this.datePicker = input
                                }}
                            />
                            {p_.icon && (
                                <div
                                    className={cn(styles.icon, p_.disabled ? styles.disabled : '')}
                                    onMouseDown={this.onIconMouseDown}
                                    onClick={error ? undefined : this.onIconClick}
                                >
                                    <Icon
                                        type={p_.icon}
                                        color={this.getIconColor(iconColor, mod)}
                                        size={error ? 11 : iconSize}
                                        disabled={p_.disabled}
                                    />
                                </div>
                            )}
                        </div>
                        {error && (
                            <div className={styles.errorContainer}>
                                <span className={cn(styles.errorText, styles[`errorText_type_${mod}`])}>{error}</span>
                            </div>
                        )}
                    </div>
                )}
                {errorText && <div className={cn(styles.error, styles.errorField)}>{errorText}</div>}
            </div>
        )
    }
}

export default EditText
